module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "toast-container",
    on: {
      "click": function($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "toast-inner"
  }, [_c('div', {
    staticClass: "toast",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    },
    on: {
      "click": function($event) {
        _vm.show = false;
      }
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6401abf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = 322
// module chunks = 1